var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"m-0 p-0 text-[44px] leading-[52px] font-bold",class:[_vm.color]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }